module.exports = __webpack_public_path__ + "media/images/posts/jar-a65e033c4cf67aaf47cb5bd67ec16ca4.jpg";